import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import { Loader, Dimmer } from "semantic-ui-react";
import useTable from "../components/useTable";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import axios from "axios";

const CatalogoPersonaAthos = (props) => {
  const op = require("../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");

  const btnAcepta = useRef();
  const btnCancela = useRef();
  const txtPersona = useRef([]);

  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    { label: "CÉDULA", textAlign: "center" },
    { label: "NOMBRES", textAlign: "center" },
    { label: "APELLIDOS", textAlign: "center" },
  ];

  let values = {};

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              (x.nacionalidad + x.cedula)
                .toLowerCase()
                .includes(target.value) ||
              x.apellidos.toLowerCase().includes(target.value.toLowerCase()) ||
              x.nombres.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarPersonasTodas = () => {
    let campos =
      "cedula, trim(nombres) as nombres, trim(apellidos) as apellidos, trim(direccion) as direccion, trim(correoe) as correoe, trim(tlf1) as tlf1, trim(tlf2) as tlf2, nacionalidad, sexo, fnacimiento";
    let nomtab = "persona";
    let orden = "cedula";

    let endpoint = `${op.conexion}/api/athos/consulta/seleccionarregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          let perso = [];
          for (let i = 0; i < response.data.length; i++) {
            perso.push({
              cedula: response.data[i].cedula,
              nombres: response.data[i].nombres,
              apellidos: response.data[i].apellidos,
              correoe: response.data[i].correoe,
              tlf1: response.data[i].tlf1,
              tlf2: response.data[i].tlf2,
              fnacimiento: response.data[i].fnacimiento,
              nacionalidad: response.data[i].nacionalidad,
              sexo: response.data[i].sexo,
              direccion: response.data[i].direccion,
            });
          }
          setRecords(perso);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "error al cargar los registros",
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelaCatPer();
  };

  const seleccionarPersona = () => {
    blanquear();
    props.onHideAceptaCatPer(values);
  };

  const seleccionarFila = (item, index) => {
    const cedPer = item.cedula;
    const nomPer = item.nombres;
    const apePer = item.apellidos;
    const correoPer = item.correoe;
    const tlf1Per = item.tlf1;
    const tlf2Per = item.tlf2;
    const fnacPer = item.fnacimiento;
    const nacPer = item.nacionalidad;
    const sexoPer = item.sexo;
    const direPer = item.direccion;

    values = {
      cedPer,
      nomPer,
      apePer,
      correoPer,
      tlf1Per,
      tlf2Per,
      fnacPer,
      nacPer,
      sexoPer,
      direPer,
    };

    for (let i = 0; i < txtPersona.current.length; i++) {
      if (i === index) {
        txtPersona.current[i].style.backgroundColor = "lightskyblue";
      } else {
        txtPersona.current[i].style.backgroundColor = "white";
      }
    }

    btnAcepta.current.focus();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarPersonasTodas();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Seleccionar Persona</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} inverted>
          <Loader inverted>Cargando...</Loader>
        </Dimmer>
        <div className="col-md-12" style={{ marginBottom: "10px" }}>
          <div className="row">
            <div className="input-group col-md-6 input-group-sm mb-3">
              <input
                type="text"
                onChange={handleSearch}
                className="form-control"
              />
              <button
                className="btn btn-info"
                style={{ pointerEvents: "none" }}
              >
                <i className="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={index}
                    ref={(el) => (txtPersona.current[index] = el)}
                    onClick={() => seleccionarFila(item, index)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.nacionalidad + item.cedula}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.nombres}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.apellidos}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          className="btn btn-sm btn-success rounded-pill"
          style={{ margin: "5px" }}
          onClick={seleccionarPersona}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoPersonaAthos;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoPersonaAthos.js